import { inject, Injectable, signal } from '@angular/core';

import { Observable } from 'rxjs';
import { IVoiceMapResponse } from '../types/interfaces/voice-map-response.interface';
import { WeatherDisplayModel } from './weather-forecast.service';

import { WebApiService } from './web-api.service';
import { TripWizardStateService } from '../../shared/components/trip-wizard/trip-wizard-state.service';
import { Trip } from '../../shared/classes/trip';

export interface CountryInfo {
  description: string;
  imageLicense: string;
  imageOwner: string;
  imageOwnerUrl: string;
  imageSource: string;
  imageTitle: string;
  imageUrl: string;
  name: string;
  place_id: number;
  regions: any[];
  wikiImg: string;
  capital: string;
  topDest: number;
  flag: string;
  currency: string;
  electricity: string;

  // present only on UI part
  visibleRegions?: number[];
  visibleCities?: number[];
  isRegionsVisible?: boolean;
  isCityVisible?: boolean;
  citiesList$?: Observable<any[]>;
  weatherForecast?: Observable<WeatherDisplayModel>;
}

@Injectable()
export class CountryInfoService {
  #tripWizardStateService: TripWizardStateService = inject(
    TripWizardStateService,
  );

  constructor(private webApiService: WebApiService) {}

  getCountriesList(): Observable<CountryInfo[]> {
    return this.webApiService.get('info/countries');
  }

  getCitiesListByCountry(contryPlaceId: number): Observable<any[]> {
    return this.webApiService.get('info/cities?id=' + contryPlaceId);
  }

  getCountryInfo(pathUrl: string): Observable<any> {
    return this.webApiService.get(`info/destinations${pathUrl}`);
  }

  getVoiceMapInfoList(cityId: string | number): Observable<IVoiceMapResponse> {
    return this.webApiService.get(`voicemap/all/${cityId}`);
  }

  getThingsToDoInCity(slug: string): Observable<any> {
    return this.webApiService.get(`info/thingsToDo/${slug}`);
  }

  setPerfectTripState(
    placeId: number | string,
    countryId: number | string,
    locationName: string,
  ): void {
    const tripState = signal(
      this.#tripWizardStateService.currentTripStateValue,
    );
    const { numDays } = tripState();

    tripState.update((trip) =>
      trip.updateTrip({
        name: '',
        savesId: '',
        blogUrl: '',
        isOptimizedMode: true,
        startingCountry: String(countryId),
        startingLabel: locationName,
        startingLocationId: String(placeId),
        endingCountry: String(countryId),
        endingLabel: locationName,
        endingLocationId: String(placeId),
        numDays: numDays || 10,
        plannerInfo: {
          type: 'classic',
          name: '',
          description: '',
        },
        includes: [],
        excludes: [],
      }),
    );
    this.#tripWizardStateService.currentTripState = new Trip({
      ...tripState(),
    });
    this.#tripWizardStateService.byUserInteraction = true;
  }
}
